module.exports = __webpack_public_path__ + "media/logos/instagram-logo-white-973a97d0.svg";